import { Link as LinkMui, styled } from '@mui/material';
import Link from "@mui/material/Link";

export const StyledLink = styled(LinkMui)({
   textDecoration: 'none',
});

export const StyledLinkBlue = styled(Link)({
   textDecoration: 'none',
   color: '#3B82F6',
});

export const StyledLinkBlueHoverDarkBlue = styled(Link)({
   textDecoration: 'none',
   color: '#3B82F6',

   '&:hover': {
      color: '#151686 !important',
   },
});

export const LinkBlue = styled(Link)({
   color: '#3B82F6',
});

export const NavbarLink = styled(Link)({});
